export default {
  paged: {
    select: 'id,email,isSuccessfulOperation,accessType,operationType,created,city,state,ip',
    // Matches list search / highlight columns (email, location, IP).
    searchSelect: ['email', 'city', 'state', 'ip'],
    notSelectSearch: 'user',
    expand: {
      appClient: {
        select: 'applicationName',
      },
      country: {
        select: 'name',
      },
    },
    orderBy: 'created desc',
  },
  itemDetail: {
    select:
      'id,email,isSuccessfulOperation,internalUserId,userId,ip,accessType,operationType,created,observations,city,state,userAgent,accessPolicyId,accessPolicyName,accessPolicyEffect,accessPolicyDecision,accessPolicyMatchedPath,accessPolicyEvaluation',
    expand: {
      appClient: {
        select: 'applicationName',
      },
      country: {
        select: 'name',
      },
      app: {
        select: 'name',
      },
      portal: {
        select: 'name',
      },
    },
  },
};
